import React, { useRef } from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import { useBlueprintBindings } from '../utils/blueprint-bindings-context'
import type { GroveBlueprintComponentProps } from '../utils/grove-blueprint-component-props'
import { RenderGroveBlueprintNode } from '../utils/render-grove-blueprint-node'
import { resolveBoxAlignment } from '../utils/resolve-box-alignment'
import { resolveModifiers } from '../utils/resolve-modifiers'
import { ScrollViewPositionContext } from '../utils/scroll-view-position-context'

export function GroveBlueprintBox({ node }: GroveBlueprintComponentProps) {
  const { getRemoteString } = useRemoteStrings()
  const { bindingValues } = useBlueprintBindings()

  const scrollViewPositionRef = useRef(0)

  /* v8 ignore if -- @preserve */
  if (node.type !== 'Box') {
    return null
  }

  const {
    className: modifierClasses,
    style: modifierStyles,
    attributes,
  } = resolveModifiers(node.modifiers, bindingValues, (key: string) =>
    getRemoteString({ key }),
  )

  const alignmentClass = resolveBoxAlignment(node.props?.alignment)

  return (
    <ScrollViewPositionContext.Provider value={scrollViewPositionRef}>
      <div
        className={`grid grid-cols-1 w-full flex-1 min-h-0 overflow-hidden ${alignmentClass} ${modifierClasses}`.trim()}
        style={modifierStyles}
        {...attributes}
      >
        {node.children?.map((child, index) => (
          <div
            className={
              '[grid-area:1/1] w-full flex flex-col overflow-hidden min-h-0 max-h-full'
            }
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          >
            <RenderGroveBlueprintNode node={child} />
          </div>
        ))}
      </div>
    </ScrollViewPositionContext.Provider>
  )
}
